module.exports = __webpack_public_path__ + "img/Clustering2.4b098704.png";